import { IKnmFormRiskIndicators } from '../interfaces/IKnmFormRiskIndicators';
import { FormErrors } from '../types/FormErrors';
import { makeRequired } from '../../../CorePackage/MainModule/validators/isRequired';

export const getRiskIndicatorsValidate = (
  riskIndicators: IKnmFormRiskIndicators[] | undefined,
  indicatorRiskRequiredFile: boolean | undefined,
): FormErrors<IKnmFormRiskIndicators>[] | string | undefined => {
  if (!riskIndicators || !riskIndicators?.length) {
    return 'Поле не может быть пустым';
  }

  return riskIndicators?.map(item => ({
    riskIndicator: makeRequired('Поле не может быть пустым')(item.riskIndicator),
    indicatorRiskAttachment:
      indicatorRiskRequiredFile === true && !item?.indicatorRiskAuto
        ? makeRequired('Поле не может быть пустым')(item?.indicatorRiskAttachment)
        : undefined,
  }));
};
